const DetailsProductData = ({
  AppealType,
  Modality,
}) => ({
  appealType: AppealType ?? '',
  modality: Modality ?? '',
})

export default DetailsProductData
